var exports = {
  "h": "x9245d464--bf63d2--description",
  "o": "x9245d464--bf63d2--cian-mortgage-button",
};

module.exports = exports;
